import { render } from "./address_info.vue?vue&type=template&id=a42a90fa"
import script from "./address_info.vue?vue&type=script&lang=js"
export * from "./address_info.vue?vue&type=script&lang=js"
script.render = render

export default script